<template>
  <div id="app">
    <div class="container">
      <nav class="navbar" role="navigation" aria-label="main navigation">
        <div class="navbar-brand">
          <router-link class="navbar-item" to="/">
            <p class="navbar-title">EUploader</p>
          </router-link>
          <div v-if="isMobile" v-show="!this.$store.state.isLoggedIn" class="navbar-item">
            <router-link class="button is-success" to="/login">{{ $t("message.login") }}</router-link>
          </div>
          <a @click="ctoggle" :class="{'navbar-burger burger': true, 'is-active': this.$store.state.ctoggleData}"
             role="button" aria-label="menu" aria-expanded="false" data-target="navbarBasic">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div id="navbarBasic"
             :class="{true: 'navbarBasic', 'navbar-menu': true, 'is-active': this.$store.state.ctoggleData}">
          <div class="navbar-start">
            <router-link @click.native="ctoggle" class="navbar-item" to="/contact">{{ $t("message.contact.title") }}</router-link>
            <router-link @click.native="ctoggle" class="navbar-item" to="/faq">{{ $t("message.faq.title") }}</router-link>
            <router-link @click.native="ctoggle" class="navbar-item" to="/subscription">{{ $t("message.subscription.title")}}</router-link>
          </div>
          <div class="navbar-end" v-show="!this.$store.state.isLoggedIn">
            <div class="navbar-item">
              <div class="buttons is-centered">
                <router-link @click.native="ctoggle" class="button is-primary" to="/signup">
                  <strong>{{ $t("message.signup") }}</strong>
                </router-link>
                <router-link v-if="!isMobile" @click.native="ctoggle" class="button is-success" to="/login">{{ $t("message.login") }}</router-link>
              </div>
            </div>
          </div>
          <div class="navbar-end" v-show="this.$store.state.isLoggedIn">
            <div class="navbar-item">
              <div class="buttons is-centered">
                <router-link v-if="!this.$store.state.isPremium" @click.native="ctoggle" class="button is-primary"
                             to="/subscription">
                  <strong>{{ $t("message.subscription.title") }}</strong>
                </router-link>
                <router-link @click.native="ctoggle" class="button is-primary" to="/list">
                  <p>{{ $t("message.list") }}</p>
                </router-link>
              </div>
            </div>
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                {{ this.$store.state.email }}
              </a>
              <div class="navbar-dropdown">
                <router-link to="/unsubscription" @click.native="ctoggle" class="navbar-item">{{ $t("message.unsubscription") }}</router-link>
                <router-link to="/logout" @click.native="ctoggle" class="button is-success">{{ $t("message.logout") }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="info is-center" v-bind:class="this.$store.state.infoLevel">
        <p class="has-text-weight-bold">{{ this.$store.state.infoMsg }}</p>
        <p class="info-date">{{ this.$store.state.infoDate }}</p>
      </div>
    </div>
    <div class="container cmain">
      <adsense v-if="!isMobile"
               ad-client="ca-pub-6042959271745689"
               ad-slot="7402635077"
               ad-style="display:block"
               ad-format="auto"
               ad-full-width-responsive="true">
      </adsense>
      <br v-if="!isMobile">
      <router-view/>
      <br>
      <adsense
        ad-client="ca-pub-6042959271745689"
        ad-slot="6877921275"
        ad-style="display:block"
        ad-format="auto"
        ad-full-width-responsive="true">
      </adsense>
      <h1>直リンクできる無料の画像・ファイルアップローダー</h1>
    </div>
    <hr>
    <div class="container is-fluid">
      <footer class="footer">
        <div class="content has-text-centered">
          <router-link to="/terms_of_service">{{ $t("message.tos") }}</router-link>
          |
          <router-link to="/asct">{{ $t("message.asct") }}</router-link>
          <p>
            <br>Hosted
            <strong>{{ this.$store.state.count }}</strong> files.
          </p>
          <social-sharing url="https://uploader.xzy.pw/"
                          title="Easy Uploader - 直リンクできて無料でファイルをアップロードできるシンプルなファイル・画像アップローダー"
                          description="簡単で直感的な直リンクできるファイル・画像アップローダーです。URLを知ってる人のみしかアクセスできないため、安心で安全です。自分から URL を教えない限り他人がファイルにアクセスすることはできません ファイルは直リンクで開けることができるため、SNS や 5ch を始めとした掲示板等で画像を直接表示させることが可能です。"
                          quote="直リンクできて無料でファイルをアップロードできるシンプルなファイル・画像アップローダー"
                          inline-template>
            <div>
              <network network="twitter">
                <span><img src="/static/images/twitter.svg" width="16" alt="アップローダー"></span> Twitter
              </network>|
              <network network="facebook">
                <span><img src="/static/images/facebook.svg" width="16" alt="アップローダー"></span> Facebook
              </network>
            </div>
          </social-sharing>
          <div>
            Icons made by <a href="https://www.freepik.com/" title="Freepik">Freepik</a> from <a
            href="https://www.flaticon.com/" title="Flaticon">www.flaticon.com</a> is licensed by <a
            href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank">CC 3.0
            BY</a>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
/*
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/static/sw.js').then(registration => {
    }).catch(registrationError => {
    })
  })
}
*/
export default {
  name: 'EasyUploader',
  data () {
    return {
      isMobile: false
    }
  },
  methods: {
    // ナビバー開いた後に閉じるやつ
    ctoggle: function () {
      if (this.$store.state.ctoggleData) {
        this.$store.commit('ctoggle', false)
      } else {
        this.$store.commit('ctoggle', true)
      }
    }
  },
  created: function () {
    // モバイルだったら、 router-view の上のアドセンス表示させない
    const isMobileJS = require('ismobilejs')
    this.isMobile = isMobileJS.phone
    // Cookie があったら、ログイン情報を取得する
    const ck = document.cookie.match(new RegExp('(^|\\s)easyuploader_api=([^;]+)'))
    if (ck) {
      this.$axios.get(this.baseURL + '/init', {withCredentials: true}).then(response => {
        if (response.data !== 'no_login') {
          this.$store.commit('setLogin',
            {email: response.data.email, isLoggedIn: true, isPremium: response.data.is_premium})
        }
      }).catch(() => {
      })
    }
    // get hosted files
    this.$axios.get(this.baseURL + '/count').then(response => {
      this.$store.commit('updateCount', response.data)
    }).catch(() => {
    })
    this.$i18n.locale = (window.navigator.userLanguage || window.navigator.language || window.navigator.browserLanguage).substr(0, 2) === 'ja' ? 'ja' : 'en'
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Kosugi+Maru&subset=japanese');
  html {
    background-color: #dbedf3;
    font-family: 'Kosugi Maru', sans-serif;
    letter-spacing: 0.04rem;
  }
  @media only screen and (max-device-width: 480px) {
    html {
      letter-spacing: 0.02rem;
    }
  }
  #app {
    font-family: 'Kosugi Maru', sans-serif;
    font-weight: bolder;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    margin-top: 30px;
  }
  .cmain {
    padding: 0 1rem 0 1rem
  }
  h2 {
    font-size: 1.5rem;
    font-weight: bolder;
  }
  hr {
    background-color: #404b69
  }
  footer {
    margin: -1rem 0 0 0;
  }
  .navbar-brand {
    background-color: #dbedf3;
  }
  .navbar-title {
    font-family: 'Kosugi Maru', sans-serif;
    font-size: 1.8rem;
  }
  .navbar-menu {
    background-color: #dbedf3;
  }
  .navbar-item {
    font-size: 1.2rem;
    background-color: #dbedf3;
  }
  a.navbar-item:hover {
    color: #dbedf3;
    background-color: #404b69;
  }
  // child
  a.navbar-item.router-link-exact-active.router-link-active {
    background-color: #dbedf3;
    color: #404b69;
  }
  // title
  a.navbar-item.router-link-active {
    background-color: #dbedf3;
    color: #404b69;
  }
  .navbar-item.has-dropdown.is-hoverable > a.navbar-link {
    background-color: #dbedf3;
  }
  .navbar-item.has-dropdown.is-hoverable > a.navbar-link:hover {
    background-color: #dbedf3;
  }
  .navbar-dropdown {
    background-color: #dbedf3;
  }
  .navbar-dropdown > a.navbar-item:hover {
    color: #dbedf3;
    background-color: #404b69;
  }
  .navbar-item.has-dropdown.is-hoverable:hover {
    background-color: #404b69;
  }
  .info {
    margin: 0 0 2rem 0;
    padding: 1rem;
  }
  .button.is-primary {
    background-color: #f73859;
  }
  .button.is-primary:hover {
    background-color: #f73859;
  }
  .button.is-success {
    background-color: #283149;
  }
  .button.is-success:hover {
    background-color: #283149;
  }
  .footer {
    background-color: #dbedf3;
    color: #404b69;
  }
  .lds-roller {
    display: inline-block;
    position: relative;
    width: 64px;
    height: 64px;
  }
  .lds-roller div {
    animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    transform-origin: 32px 32px;
  }
  .lds-roller div:after {
    content: " ";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #cef;
    margin: -3px 0 0 -3px;
  }
  .lds-roller div:nth-child(1) {
    animation-delay: -0.036s;
  }
  .lds-roller div:nth-child(1):after {
    top: 50px;
    left: 50px;
  }
  .lds-roller div:nth-child(2) {
    animation-delay: -0.072s;
  }
  .lds-roller div:nth-child(2):after {
    top: 54px;
    left: 45px;
  }
  .lds-roller div:nth-child(3) {
    animation-delay: -0.108s;
  }
  .lds-roller div:nth-child(3):after {
    top: 57px;
    left: 39px;
  }
  .lds-roller div:nth-child(4) {
    animation-delay: -0.144s;
  }
  .lds-roller div:nth-child(4):after {
    top: 58px;
    left: 32px;
  }
  .lds-roller div:nth-child(5) {
    animation-delay: -0.18s;
  }
  .lds-roller div:nth-child(5):after {
    top: 57px;
    left: 25px;
  }
  .lds-roller div:nth-child(6) {
    animation-delay: -0.216s;
  }
  .lds-roller div:nth-child(6):after {
    top: 54px;
    left: 19px;
  }
  .lds-roller div:nth-child(7) {
    animation-delay: -0.252s;
  }
  .lds-roller div:nth-child(7):after {
    top: 50px;
    left: 14px;
  }
  .lds-roller div:nth-child(8) {
    animation-delay: -0.288s;
  }
  .lds-roller div:nth-child(8):after {
    top: 45px;
    left: 10px;
  }
  @keyframes lds-roller {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue